import React from 'react';

import {GetAnalysisScratchFile} from 'analysis-tool/AnalysisTypes';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import Chip, {ChipSize} from 'ui-library/chips/Chip';

interface ExternalFileChipProps {
  scratchFile: GetAnalysisScratchFile;
}

export default function ExternalFileChip({scratchFile}: ExternalFileChipProps): JSX.Element {
  async function handleClick(): Promise<void> {
    const signedURL = await performSignedFileQuery(
      scratchFile.externalFileId!,
      scratchFile.downloadUrl!,
      scratchFile.id
    );
    if (signedURL == null) {
      return;
    }
    window.open(signedURL, '_blank', 'noopener noreferrer');
  }

  return (
    <Chip
      className="chip-container"
      icon={ModelTypeConstants.EXTERNAL_FILE}
      onClick={handleClick}
      size={ChipSize.SMALL}
      text={scratchFile.filename}
    />
  );
}
